import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import style from './index.css';

import YuanChuangNav from './yuanchuangNav';
import errorBoundary from '@ifeng/errorBoundary';

class LogoNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { logoData, navData } = content;

        const fragementID = navData && navData.id ? navData.id.toString() : '';

        return (
            <div>
                <div className={style.logo}>
                    <span />
                </div>
                <div className={style.sub_logo}>
                    <img src={logoData} alt="" />
                </div>
                {navData && navData.type ? (
                    <Chip id={fragementID} type={navData.type} title="导航" groupName="头部" content={navData.content}>
                        <YuanChuangNav />
                    </Chip>
                ) : null}
            </div>
        );
    }
}
export default errorBoundary(LogoNav);
